import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxSpinnerComponent } from './phx-spinner.component';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  declarations: [PhxSpinnerComponent],
  imports: [CommonModule, PhxIconModule],
  exports: [PhxSpinnerComponent],
})
export class PhxSpinnerModule {}
